import React from 'react';
import { Button } from 'antd';
import illustrations from '../NullStates/illustrations';

const ErrorFallback = () => {
  const handleButtonClick = () => {
    // if (resetErrorBoundary) {
    //   resetErrorBoundary();
    //   return;
    // }
    window.location.reload();
  };

  return (
    <div className="null-state generic">
      {illustrations.risks}
      <div className="null-state-content">
        <h1 className="null-state-title">Oops! Something Went Wrong!</h1>
        <p>Please refresh this page to try again.</p>
      </div>
      <Button
        className="btn purple-action-btn remove-padding-left  null-state-action refresh"
        type="primary"
        onClick={handleButtonClick}
      >
        <i className="icon fi-bs-refresh" />
        Refresh
      </Button>
    </div>
  );
};

export default ErrorFallback;
